// src/screens/TransaccionesScreen.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getClicksHistory } from '../services/authService';

const REASON_LABELS = {
  bienvenida: 'Bono de bienvenida',
  referido_bono: 'Bono por referido',
  referido_recurrente: 'CLICKs por servicio de tu referido',
  servicio_manual: 'CLICKs por servicio',
  canje: 'Canje de premio',
};

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export default function TransaccionesScreen({ onClose }) {
  const { user } = useAuth();
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) return;
    getClicksHistory(user.uid).then(data => { setMovements(data); setLoading(false); });
  }, [user?.uid]);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--bg)', zIndex: 300, overflowY: 'auto' }}>
      <div style={{ padding: '24px 16px 40px', maxWidth: 480, margin: '0 auto' }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <p style={{ fontSize: 11, color: 'var(--orange)', fontWeight: 700, letterSpacing: 1 }}>HISTORIAL</p>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: 'var(--white)' }}>Mis transacciones</h2>
          </div>
          <button onClick={onClose} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', color: 'var(--muted)', borderRadius: 8, padding: '8px 14px', fontSize: 13 }}>✕ Cerrar</button>
        </div>

        {loading && <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>Cargando...</p>}

        {!loading && movements.length === 0 && (
          <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 24, textAlign: 'center' }}>
            <p style={{ fontSize: 28, marginBottom: 8 }}>📄</p>
            <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
              Aún no tienes movimientos de CLICKs registrados.
            </p>
          </div>
        )}

        {movements.map(m => {
          const positive = m.amount >= 0;
          return (
            <div key={m.id} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              background: 'var(--navy-card)', border: '1px solid var(--navy-border)',
              borderRadius: 14, padding: '14px 16px', marginBottom: 10,
            }}>
              <div>
                <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--white)' }}>
                  {REASON_LABELS[m.reason] || m.reason}
                </p>
                <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{formatDate(m.created_at)}</p>
              </div>
              <p style={{ fontSize: 18, fontWeight: 800, color: positive ? 'var(--success)' : 'var(--error)' }}>
                {positive ? '+' : ''}{m.amount}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
